import { defineProvider } from '@nuxt/image/runtime';

export default defineProvider({
    getImage(url) {
        return {
            url,
        };
    },
});
